const STORAGE_KEY = 'analyticsKey';

const getStoredKey = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    return sessionStorage.getItem(STORAGE_KEY) || '';
};

const setStoredKey = (value) => {
    if (typeof window === 'undefined') {
        return;
    }
    if (value) {
        sessionStorage.setItem(STORAGE_KEY, value);
        return;
    }
    sessionStorage.removeItem(STORAGE_KEY);
};

export const getAdminKey = () => getStoredKey();

export const setAdminKey = (value) => {
    const normalized = typeof value === 'string' ? value.trim() : '';
    if (normalized) {
        setStoredKey(normalized);
        return normalized;
    }
    setStoredKey('');
    return '';
};

export const clearAdminKey = () => {
    setStoredKey('');
};

export const isAdminAuthenticated = () => Boolean(getStoredKey());
